"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var click_outside_directive_1 = require("./click-outside.directive");
exports.ClickOutsideDirective = click_outside_directive_1.ClickOutsideDirective;
var click_outside_module_1 = require("./click-outside.module");
exports.ClickOutsideModule = click_outside_module_1.ClickOutsideModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng-click-outside/lib/index.js
// module id = 237
// module chunks = 1